import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID!,
      userPoolClientId: process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID!,
      loginWith: {
        username: true
      }
    }
  }
}, { ssr: false });

// Set the storage provider for Cognito tokens
cognitoUserPoolsTokenProvider.setKeyValueStorage({
  getItem: async (key: string) => {
    return localStorage.getItem(key);
  },
  setItem: async (key: string, value: string) => {
    localStorage.setItem(key, value);
    return;
  },
  removeItem: async (key: string) => {
    localStorage.removeItem(key);
    return;
  },
  clear: async () => {
    localStorage.clear();
    return;
  }
});